import { useUserStore } from '@/stores/userStore';
import axios from 'axios';

const api = axios.create({
  baseURL:
    import.meta.env.VITE_API_BASE_URL +
    (import.meta.env.VITE_API_VERSION ? '/' + import.meta.env.VITE_API_VERSION : ''),
});

api.interceptors.request.use(
  async (config) => {
    const userStore = useUserStore();
    const token = userStore.getAccessToken();
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Refactor URL to ensure it ends with a slash and properly handles query parameters.
 * This is necessary because the backend API expects URLs to end with a slash.
 * Also helps in preventing 301 redirect request from the server when URLs are not properly formatted.
 * For example:
 * - /api/resource -> /api/resource/
 * - /api/resource?param=value -> /api/resource/?param=value
 */
api.interceptors.request.use(
  async (config) => {
    const formatUrl = (url) => {
      return url.replace(
        /^(\/)?([^?]*?)(\/)?(\?.*)?$/,
        (_, leading, path, trailing, query) => '/' + path.replace(/^\/|\/$/g, '') + '/' + (query || '')
      );
    };
    config.url = formatUrl(config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to recover from invalid or expired Knox auth.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const userStore = useUserStore();
    const status = error.response?.status;
    const detail = error.response?.data?.detail;

    if ((status === 401 || (status === 403 && detail === 'Invalid token')) && userStore.hasAccessToken()) {
      userStore.clearAuthState();
      localStorage.setItem('return_to', window.location.pathname + window.location.search + window.location.hash);
      await userStore.loginWithProvider('oidc_auth0', '/callback');
    }

    return Promise.reject(error);
  }
);

export default api;
